var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title wf-gothicfont",class:_vm.titleType,attrs:{"title":_vm.titleText}},_vm._l((_vm.texts),function(t,i){return _c('span',{key:i,style:({'animation-duration': `${1 + (i * 0.2)}s`})},[_vm._v(_vm._s(t))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }